export const DIMENSION_LABEL_WIDTH_PX = 40;
export const GRIDLINE_TICK_GAP_PX = 5;
export const EXTRA_DIMENSION_GUTTER_PX = 20;
export const DIMENSION_LABEL_TOP_PX = 10;
export const DIMENSION_LABEL_LINE_OFFSET_PX = 8;
export const DIMENSION_GUIDE_DOT_SIZE_PX = 4;
export const DIMENSION_GUIDE_LINE_THICKNESS_PX = 1;
export const DIMENSION_INPUT_WIDTH_PX = 160;
export const DIMENSION_TOOLTIP_DELAY_MS = 1500;
